module.exports = __webpack_public_path__ + "img/ring_y_s_1_null@2x.c2f69eac.png";